// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__3UkM5","footer":"ChangeClinic_footer__1u1CT"};